module.exports = __webpack_public_path__ + "media/bonus_animal_hit.64f770c7.mp3";